import { EntityImageConfig } from 'components/upload-image-modal';
import { ROLE_CODES } from 'constants/role.constants';

export const EXISTING_ACCOUNT_WARNING = `WARNING: This user whose information you want to update is
 associated with one or more other organizations. Please contact support@certemy.com to request an update to
 this information.`;
export const EXISTING_ACCOUNT_WARNING_PROF_ADDITIONAL = `Alternatively, the {professional} in question may update their
information directly through their account.`;
export const EMAIL_ALREADY_EXISTS_IN_THE_SYSTEM_WARNING = `WARNING: The e-mail you have entered already exists in the system. Please enter a different e-mail.`;
export const EXISTING_ACCOUNT_CONFIRMATION_TEXT = `WARNING: This user has profiles in multiple organizations. Please confirm you would still like to proceed.`;
export const INCORRECT_MANAGER_SELECT =
  'WARNING: The user you have selected to be the Manager for this profile is already managed by the profile you are editing or managed by someone this profile you are editing manages.';

export const DELETED_MANAGER_SELECT =
  'The manager for this user is no longer active. Please select a different manager for this user or, if this user no longer has a manager, please leave the manager selection blank.';
export const VALID_MANAGER_LOCATIONS =
  'This user manages one or more professionals that are no longer associated with the {office}(s) listed above. Please edit the {office} selection above. If you would like to continue, please note that the professionals in question will no longer be visible to this manager.';
export const EDIT_VALIDATION_ERRORS = {
  EMPTY_ADDITIONAL_REGION: 'Please select at least one additional {region} and one additional {office}.',
  EMPTY_ADDITIONAL_OFFICE: 'Please select at least one additional {office}.',
  EQUAL_ADDITIONAL_OFFICE:
    'Please select a different additional {office}. The one you have selected has already been selected as a primary {office}.',
};
export const REMOVE_MANAGER = 'Removing the manager may revoke their access to this user’s information. Continue?';

export interface IUpdateProfile {
  additionalCountryIds: number[];
  additionalOfficeIds: number[];
  additionalRegionIds: number[];
  avatar: EntityImageConfig;
  country_id: number;
  country_ids: number[];
  email: string;
  first_name: string;
  last_name: string;
  mobileCountryId: number;
  mobilePhoneNumber: string;
  office_id: number;
  office_ids: number[];
  organizationRoleId: number;
  profile_type_id: number;
  region_id: number;
  region_ids: number[];
  organization_id: number;
  role_id: ROLE_CODES;
  profile_id: number;
  organization_profile_id: string;
}
